import { useSearchDateShortcut } from '@/hooks/useSearch'
import { secondToString } from '@/utils/date-format'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { LiveRecord } from './live-record.service'

interface LiveRecordSearchContext {
  channelOptions: CrudSelectOption[]
  departmentOptions: CrudSelectOption[]
  employeeOptions: CrudSelectOption[]
  isManager: boolean
  optionsLoading: boolean
}

export function createLiveRecordSearchItems(
  context: LiveRecordSearchContext
): CrudSearchItem[] {
  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择直播间',
      options: context.channelOptions
    },
    {
      label: '客户昵称',
      prop: 'consumerNickName',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      label: '客户unionId',
      prop: 'consumerWxUnionId',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户unionId'
    },
    {
      label: '访问时长',
      prop: 'duration',
      type: 'select',
      clearable: true,
      placeholder: '请选择访问时长',
      options: [
        { label: '≥ 1分钟', value: '60' },
        { label: '≥ 5分钟', value: '300' },
        { label: '≥ 10分钟', value: '600' },
        { label: '≥ 20分钟', value: '1200' },
        { label: '≥ 25分钟', value: '1500' },
        { label: '≥ 30分钟', value: '1800' },
        { label: '≥ 40分钟', value: '2400' },
        { label: '≥ 50分钟', value: '3000' },
        { label: '≥ 60分钟', value: '3600' }
      ]
    },
    {
      label: '访问时间',
      prop: 'accessTime',
      type: 'dateTimeRange',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      shortcuts: useSearchDateShortcut(),
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    },
    {
      label: '部门',
      prop: 'deptId',
      type: 'select',
      clearable: true,
      disabled: !context.isManager,
      placeholder: '请选择部门',
      options: context.departmentOptions
    },
    {
      label: '员工',
      prop: 'empIds',
      type: 'select',
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择员工',
      options: context.employeeOptions
    }
  ]
}

export const liveRecordTableColumns: CrudTableColumn<LiveRecord>[] = [
  {
    prop: 'consumerNickName',
    label: '客户昵称',
    slot: 'consumer',
    minWidth: 160,
    align: 'left',
    showOverflowTooltip: true
  },
  {
    prop: 'channelName',
    label: '直播间名',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'deptName',
    label: '所属部门',
    minWidth: 100,
    showOverflowTooltip: true
  },
  {
    prop: 'empName',
    label: '所属员工',
    minWidth: 100,
    showOverflowTooltip: true
  },
  {
    prop: 'accessTime',
    label: '访问时间',
    minWidth: 160,
    showOverflowTooltip: true
  },
  {
    prop: 'duration',
    label: '访问时长',
    minWidth: 120,
    sortable: 'custom',
    formatter: (row) => secondToString(row.duration)
  }
]
